import React from 'react';
import { match } from 'react-router';

interface SelectedItem {
  name: string;
  id: string;
  settingsUrl?: string;
}

export interface TeacherDashboardSelectedItemsContextProps {
  selectedStudent: SelectedItem | null;
  setSelectedStudent: (selectedStudent: SelectedItem | null) => void;
  selectedClass: SelectedItem | null;
  setSelectedClass: (selectedClass: SelectedItem | null) => void;
  studentIsAdminPage: boolean;
  setStudentIsAdminPage: (selectedClass: boolean) => void;
}

interface TeacherDashboardSelectedItemsContextProviderProps {
  children: React.ReactNode;
  match: match;
}

export const TeacherDashboardSelectedItemsContext = React.createContext<TeacherDashboardSelectedItemsContextProps>(
  {} as TeacherDashboardSelectedItemsContextProps
);

export const useTeacherDashboardSelectedItems = () => React.useContext(TeacherDashboardSelectedItemsContext);

/**
 * To be used mostly on the TeacherDashboardHeader (and some other components) that do not receive the route params,
 * as they are invoked outisde of it.
 */
export const TeacherDashboardSelectedItemsContextProvider = (props: TeacherDashboardSelectedItemsContextProviderProps) => {
  const [selectedStudent, setSelectedStudent] = React.useState(null as SelectedItem | null);
  const [studentIsAdminPage, setStudentIsAdminPage] = React.useState(false);
  const [selectedClass, setSelectedClass] = React.useState(null as SelectedItem | null);

  return (
    <TeacherDashboardSelectedItemsContext.Provider
      value={{
        selectedStudent,
        setSelectedStudent,
        selectedClass,
        setSelectedClass,
        studentIsAdminPage,
        setStudentIsAdminPage,
      }}
    >
      {props.children}
    </TeacherDashboardSelectedItemsContext.Provider>
  );
};
